import React from 'react';
import { Box, Typography, LinearProgress, Alert, AlertTitle } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StorageIcon from '@mui/icons-material/Storage';

interface KeywordStorageStatusProps {
  isProcessing: boolean;
  isUsingDatabaseApproach: boolean;
  analysisComplete: boolean;
  storedKeywordCount?: number;
  totalKeywordCount?: number;
}

const KeywordStorageStatus: React.FC<KeywordStorageStatusProps> = ({
  isProcessing,
  isUsingDatabaseApproach,
  analysisComplete,
  storedKeywordCount,
  totalKeywordCount
}) => {
  if (!isUsingDatabaseApproach) return null;

  if (isProcessing) {
    return (
      <Box sx={{ mt: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <StorageIcon sx={{ mr: 1, color: 'primary.main' }} />
          <Typography variant="body2">
            Storing keywords in database...
          </Typography>
        </Box>
        <LinearProgress />
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
          Keywords are being analyzed and stored for future classification
        </Typography>
      </Box>
    );
  }

  if (analysisComplete && storedKeywordCount) {
    return (
      <Alert severity="success" sx={{ mt: 2 }}>
        <AlertTitle sx={{ display: 'flex', alignItems: 'center' }}>
          <CheckCircleIcon sx={{ mr: 1 }} />
          Analysis Complete
        </AlertTitle>
        <Typography variant="body2">
          {storedKeywordCount.toLocaleString()} keywords have been stored in the database
          {totalKeywordCount && storedKeywordCount < totalKeywordCount && (
            <span> (limited from {totalKeywordCount.toLocaleString()} total)</span>
          )}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          Keywords are ready for classification in Module 4
        </Typography>
      </Alert>
    );
  }

  return null;
};

export default KeywordStorageStatus; 